export default __webpack_public_path__ + "static/media/march-min.fc31535c.jpg";